module.exports = __webpack_public_path__ + "img/bg-card-frecuente-promocion@2x.c0ac54b9.png";